/**
 * Business Module Constants
 * Centralized configuration for business-related values
 */

export const BUSINESS_CATEGORIES = [
  "Agriculture",
  "Manufacturing",
  "Trading",
  "Services",
  "Technology",
  "Health",
  "Education",
  "Hospitality",
  "Transportation",
  "Other",
] as const;

export const BUSINESS_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
} as const;

export const BUSINESS_PAGINATION = {
  ITEMS_PER_PAGE: 15,
  ADMIN_ITEMS_PER_PAGE: 10,
} as const;

export const BUSINESS_VALIDATION = {
  NAME_MAX_LENGTH: 255,
  DESCRIPTION_MAX_LENGTH: 5000,
  DESCRIPTION_MIN_LENGTH: 50,
  PHONE_MAX_LENGTH: 20,
  EMAIL_MAX_LENGTH: 255,
  WEBSITE_MAX_LENGTH: 255,
  CATEGORY_MAX_LENGTH: 255,
  ADDRESS_MAX_LENGTH: 255,
} as const;

export type BusinessStatus =
  (typeof BUSINESS_STATUS)[keyof typeof BUSINESS_STATUS];
export type BusinessCategory = (typeof BUSINESS_CATEGORIES)[number];
